import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ProjectPlanPhaseMilestoneEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestone";
        this.primaryEnterpriseComponent = "ProjectPlanPhaseMilestone";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseMilestone";
        eom.enterpriseComponent = "ProjectPlanPhaseMilestone";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseMilestoneReference";
        eom.enterpriseComponent = "ProjectPlanPhaseMilestoneReference";
        eom.relationship = "ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneReference";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseMilestoneEmployee";
        eom.enterpriseComponent = "ProjectPlanPhaseMilestoneEmployee";
        eom.relationship = "ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneEmployee";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ProjectPlanPhaseMilestoneEnterpriseObjectMetadata;